var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: {
            title: "VERIFIQUE SEU E-MAIL",
            subtitle:
              "O seu pedido será criado assim que você fizer a verificação do seu e-mail.",
            size: "md"
          },
          on: {
            close: function($event) {
              _vm.$emit("close")
            }
          }
        },
        [
          _c("template", { slot: "body" }, [
            _c("p", [
              _vm._v(
                "Caso você não tenha recebido o e-mail, clique no botão abaixo para reenviar o link de confirmação."
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                class: {
                  "btn--loading": _vm.preloader,
                  "bg-purple": !_vm.sent,
                  "bg-green": _vm.sent
                },
                on: { click: _vm.send }
              },
              [
                _vm.sent
                  ? _c("span", [_vm._v("E-mail enviado!")])
                  : _c("span", [_vm._v("Reenviar e-mail")])
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-734c73eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-734c73eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/Steps/VerifyEmail.vue
// module id = null
// module chunks = 